import GetKFMVEventStateInformationRequestModelBase from '../_generated/modelBases/get-kfmv-event-state-information-request-model-base';

export default class GetKFMVEventStateInformationRequestModel extends GetKFMVEventStateInformationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
